/**
 * Une charge lâchée sur un créneau où le compagnon a déjà un travail : au lieu de la
 * refuser, on la pose dans les trous, du point de lâcher jusqu'à la fin de journée
 * (Steeven, Héric 2026-10-13 : 9 h–16 h par-dessus un travail 10 h–11 h devient
 * 9 h–10 h puis 11 h–…). Les pauses et absences sont sautées comme les travaux ;
 * ce qui ne tient pas dans la journée reste dans la charge.
 */

const EPS = 1e-6;
const MIN_SEGMENT = 0.25; // un quart d'heure : en dessous, le morceau ne sert à rien

export interface Segment {
  startHour: number;
  duration: number;
}

export function splitAroundBusy(
  fromHour: number,
  dayEnd: number,
  hours: number,
  busy: [number, number][],
): Segment[] {
  const blocked = busy
    .filter(([s, e]) => e > fromHour + EPS && s < dayEnd - EPS)
    .sort((a, b) => a[0] - b[0]);
  const out: Segment[] = [];
  let cursor = fromHour;
  let left = hours;
  const take = (until: number) => {
    const d = Math.min(until - cursor, left);
    if (d >= MIN_SEGMENT - EPS) {
      out.push({ startHour: cursor, duration: +d.toFixed(2) });
      left = +(left - d).toFixed(2);
    }
  };
  for (const [s, e] of blocked) {
    if (left < MIN_SEGMENT - EPS) break;
    if (s > cursor + EPS) take(Math.min(s, dayEnd));
    cursor = Math.max(cursor, e);
    if (cursor >= dayEnd - EPS) break;
  }
  if (left >= MIN_SEGMENT - EPS && cursor < dayEnd - EPS) take(dayEnd);
  return out;
}
